module.exports = __webpack_public_path__ + "static/media/crema docs.b1917688.txt";